'use client';

import { type ComponentProps } from 'react';
import { AppBar } from './AppBar';
import { utilStyles } from '~/styles';
import { IcMulti, Typography } from '@bgzt/ui';
import { goToCartOnApp } from '~/services/app-interface';
import { useGetCartCount } from './useGetCartCount';
import { useEventListener } from '@bgzt/hooks';
import styles from './CartButton.module.css';

const DISPLAY_NAME = 'CartButton';

type Props = {
  config: ComponentProps<typeof AppBar>['back'];
};

export const CartButton = ({ config = true }: Props) => {
  const { data, refetch } = useGetCartCount();

  useEventListener(globalThis.window?.document, 'visibilitychange', () => {
    if (document.visibilityState === 'visible') refetch();
  });

  return (
    <button
      onClick={(event) => {
        goToCartOnApp().go();

        if (event.defaultPrevented) return;
        if (typeof config === 'boolean') return;
        config?.onClick?.(event);
      }}
      {...(config === true ? {} : config)}
      className={styles.button}
    >
      <span className={utilStyles.visuallyHidden}>장바구니로</span>
      <IcMulti size={20} />
      {!!data && (
        <span className={styles.badge}>
          <Typography variant={'L14'} color={'white'} className={styles.badgeText}>
            {data > 99 ? `99+` : data}
          </Typography>
        </span>
      )}
    </button>
  );
};

CartButton.displayName = DISPLAY_NAME;
